import type { WidgetMapper } from 'ui/containers/ContentBuilder';
import { loadable } from 'ui/utilities';

const orderinfo = loadable(
  () => import(/* webpackChunkName: "container-order-success-pix" */ './PixSuccess'),
);

export const orderPixMapper: WidgetMapper = {
  orderinfo,
};
